import Clarity from '@microsoft/clarity';

let initialized = false;

export function initializeClarity(): void {
    if (initialized || typeof window === 'undefined') {
        return;
    }

    const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

    if (!projectId) {
        console.warn(
            '[Clarity] REACT_APP_CLARITY_PROJECT_ID não foi configurado.',
        );

        return;
    }

    Clarity.init(projectId);
    initialized = true;
}